import logo from '@/assets/padu_new_logo_blue.svg'

interface HomeHeaderLogoProps {
  className?: string;
}

export default function HomeHeaderLogo({ className = '' }: HomeHeaderLogoProps) {
  return (
    <div className={`w-full max-w-[400px] mt-[-40px] lg:mt-[-150px] ${className}`.trim()}>
      {/* <MetallicPaint
        imageSrc={logo}
        seed={3}
        scale={4}
        patternSharpness={0}
        noiseScale={0.5}
        speed={0}
        liquid={0}
        mouseAnimation={false}
        brightness={2}
        contrast={0.5}
        refraction={0.01}
        blur={0.015}
        chromaticSpread={2}
        fresnel={1}
        angle={0}
        waveAmplitude={1}
        distortion={1}
        contour={0.2}
        lightColor="#00d9d9"
        darkColor="#004f50"
        tintColor="#00d9d9"
      /> */}
      <img src={logo} className="block h-full w-full object-contain" />
    </div>
  );
}
